export default {
      id: "oc-search-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite.svg#oc-search",
      toString: function () {
        return this.url;
      }
    }